<template>
  <div v-if="load">
    <b-row class="card mt-5">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-file"></i> Projeto
        </h5>
      </div>

      <div class="w-100 d-flex justify-content-between p-3">
        <div class="w-100 d-flex justify-content-end">
          <b-link :href="link" class="text-light" target="_blank">
            <b-button variant="info">Visualizar PDF</b-button>
          </b-link>
        </div>
      </div>

      <div class="w-100 p-3">
        <div class="row">
          <div class="col-md-3">
            <div class="w-100 position-relative bg-primary p-4 text-center text-light">
              <h3>Valor</h3>
              <h2>{{ project.price | currency }}</h2>
              <div class="hover" v-b-modal.edit-project v-if="$acl.check('isAdmin')">
                <b-button variant="default">
                  <i class="fas fa-pen"></i> Editar valor
                </b-button>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="w-100 bg-warning p-4 text-center text-light">
              <h3>Kwh</h3>
              <h2>{{ parseInt(project.kits[0].estimate_power_kwh) }}</h2>
            </div>
          </div>
          <div class="col-md-3">
            <div class="w-100 bg-info p-4 text-center text-light">
              <h3>Painéis</h3>
              <h2>{{ parseInt(project.kits[0].panel_count) }}</h2>
            </div>
          </div>
          <div class="col-md-3">
            <div class="w-100 bg-success p-4 text-center text-light">
              <h3>Comissão</h3>
              <h2>{{ agent_comission | currency }}</h2>
            </div>
          </div>
        </div>
        <div class="w-100 mt-5">
          <b-row>
            <b-col lg="5">
              <span>Cliente</span> <br>
              <h4>{{ project.client.name }}</h4>
            </b-col>
            <b-col lg="4">
              <span>Email</span> <br>
              <h4>{{ project.client.email }}</h4>
            </b-col>
            <b-col lg="3">
              <span>Contato</span> <br>
              <h4>{{ project.client.phone_mobile }}</h4>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="5">
              <span>Documento</span> <br>
              <h4>{{ project.client.document }}</h4>
            </b-col>
            <b-col lg="4">
              <span>Cidade</span> <br>
              <h4>{{ project.client.addresses[0].city.name }}</h4>
            </b-col>
            <b-col lg="3">
              <span>Estado</span> <br>
              <h4>{{ project.client.addresses[0].city.province.name }}</h4>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-row>

    <b-row class="card mt-5" v-if="agent">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-user"></i> Agente
        </h5>
      </div>
      <div class="w-100 p-3">
        <b-row>
          <b-col lg="5">
            <span>Nome</span><br>
            <h4>{{ agent.name }}</h4>
          </b-col>
          <b-col lg="4">
            <span>Email</span><br>
            <h4>{{ agent.email }}</h4>
          </b-col>
          <b-col lg="3">
            <span>Contato</span><br>
            <h4>{{ agent.phone_mobile }}</h4>
          </b-col>
        </b-row>

        <hr class="mt-4">

        <b-row class="mt-3 align-items-end">
          <b-col lg="3">
            <b-form-group label="Alterar Comissão">
              <b-form-radio-group v-model="commission.type"
                :options="[{ text: 'Porcentagem (%)', value: 'percent' }, { text: 'Valor Fixo (R$)', value: 'value' }]" />
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group :label="commission.type === 'percent' ? 'Comissão (%)' : 'Valor da Comissão (R$)'">
              <b-input-group :append="commission.type === 'percent' ? '%' : 'R$'">
                <b-form-input v-model="commission.input" type="number" min="0"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-form-group label="Projeção da Comissão">
              <h4 class="text-success m-0 p-2">{{ projected_commission | currency }}</h4>
            </b-form-group>
          </b-col>
          <b-col lg="3">
            <b-button variant="primary" :disabled="commission.input <= 0" @click="confirmChangeCommission"
              class="mb-3 w-100">
              <i class="fas fa-pen"></i> Atualizar Comissão
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-row>

    <b-row class="card mt-5">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-percentage"></i> Descontos aplicados
        </h5>
      </div>
      <div class="w-100 p-3" v-if="discounts.length > 0">
        <b-table :fields="columsTableDiscounts" :items="discounts" bordered responsive>
          <template v-slot:cell(actions)="row">
            <div>
              <b-button @click="deleteDiscount(row.index)" variant="danger">Excluir</b-button>
            </div>
          </template>
        </b-table>
      </div>
    </b-row>

    <b-row class="card mt-5">
      <div class="w-100">
        <h5 class="title-card">
          <i class="fas fa-solar-panel"></i> Kit
        </h5>
      </div>

      <div class="w-100 p-3" v-if="$acl.check('isInternal')">
        <b-button variant="warning" :to="{ name: 'project-edit-kit', params: { project: id } }">
          <i class="fas fa-pen"></i>
          Editar kit
        </b-button>
      </div>

      <div class="w-100 px-3">
        <b-row>
          <b-col lg="12">
            <span>Descrição</span> <br>
            <h4>{{ project.kits[0].description }}</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="3">
            <span>Potência</span><br>
            <h4>{{ project.kits[0].power_kwp }}</h4>
          </b-col>
        </b-row>
      </div>
      <hr>
      <div class="w-100 p-3">
        <h3>Componentes do Kit</h3>
        <b-table :fields="columsTableComponents" :items="project_components" bordered responsive></b-table>
      </div>
    </b-row>

    <b-modal ref="edit-project" cancel-title="Fechar" id="edit-project" ok-title="Confirmar" title="Aplicar desconto"
      @ok="updateProjectDiscount">
      <b-row>
        <b-col lg="12" class="mb-3">
          <b-form-radio-group v-model="payload.discount_type"
            :options="[{ text: 'Desconto em %', value: 'percent' }, { text: 'Desconto em R$', value: 'value' }]" />
        </b-col>
        <b-col lg="6">
          <b-form-group :label="payload.discount_type === 'percent' ? '(%) de desconto' : 'Valor direto (R$)'">
            <b-input-group :append="payload.discount_type === 'percent' ? '%' : 'R$'">
              <b-form-input :class="{ 'form-group--error': $v.payload.discount_input.$error }"
                v-model="$v.payload.discount_input.$model"
                :state="$v.payload.discount_input.$dirty ? !$v.payload.discount_input.$error : null" type="number" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group label="Valor total do desconto">
            <h5 class="bg-warning p-2">
              {{ value_discount | currency }}
            </h5>
          </b-form-group>
        </b-col>
        <b-col lg="12" class="mt-3">
          <b-form-group label="Acrescentar valor ao projeto">
            <b-input-group prepend="R$">
              <b-form-input v-model="payload.additional_value" type="number" min="0" step="0.01" />
              <b-input-group-append>
                <b-button variant="success" @click="addValueToProject">Adicionar ao valor do projeto</b-button>
              </b-input-group-append>
            </b-input-group>
            <small class="text-muted">O valor será somado ao preço do projeto imediatamente.</small>
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <div class="d-flex justify-content-center mt-2">
            <div class="p-3 text-center bg-info text-light w-100 rounded">
              <h5>Valor com desconto</h5>
              <h4 class="m-0">{{ price_final | currency }}</h4>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';
import ProjectService from '@/Services/ProjectService';
import MessagesMixin from '@/mixins/messages-mixin';
import QuestionMixin from '@/mixins/question-mixin';
import ErrorMixin from '@/mixins/error-mixin';

export default {
  props: ['id'],
  data() {
    return {
      load: false,
      discount: false,
      haveDiscount: false,
      agent_percentage_original: 0,
      columsTableComponents: ProjectService.getFieldsTableComponents(),
      columsTableAccompaniments: ProjectService.getFieldsTableAccompaniment(),
      columsTableDiscounts: ProjectService.getFieldsTableDiscounts(),
      project: {},
      project_product: {},
      project_components: {},
      product: {},
      agent: {},
      link: `${process.env.VUE_APP_PDF_LINK}${this.id}`,
      user: JSON.parse(localStorage.getItem('user')),
      all_status_departments: [],
      discounts: [],
      payload: {
        discount_type: 'percent',
        discount_input: 0,
        additional_value: '',
      },
      commission: {
        type: 'percent',
        input: 0,
      },
    };
  },
  computed: {
    agent_comission() {
      if (!this.project.price || !this.project.agent_percentage) return 0;
      return parseFloat(this.project.price) * (this.project.agent_percentage / 100);
    },
    projected_commission() {
      const price = parseFloat(this.project.price) || 0;
      const input = parseFloat(this.commission.input) || 0;
      return this.commission.type === 'percent' ? price * (input / 100) : input;
    },
    value_discount() {
      const price = parseFloat(this.project.price) || 0;
      const input = parseFloat(this.payload.discount_input) || 0;
      return this.payload.discount_type === 'percent' ? price * (input / 100) : input;
    },
    price_final() {
      const price = parseFloat(this.project.price) || 0;
      return price - this.value_discount;
    },
    final_discount_percentage() {
      if (this.payload.discount_type === 'percent') return parseFloat(this.payload.discount_input);
      return (this.value_discount / parseFloat(this.project.price)) * 100;
    },
    final_commission_percentage() {
      if (this.commission.type === 'percent') return parseFloat(this.commission.input);
      return (this.projected_commission / parseFloat(this.project.price)) * 100;
    },
  },
  validations: {
    payload: {
      discount_input: { required, decimal },
    },
  },
  mixins: [MessagesMixin, QuestionMixin, ErrorMixin],
  watch: {
    // eslint-disable-next-line object-shorthand
    'commission.type'(newType) {
      const price = parseFloat(this.project.price) || 0;
      const currentInput = parseFloat(this.commission.input) || 0;
      if (price > 0) {
        if (newType === 'value') {
          this.commission.input = (price * (currentInput / 100)).toFixed(2);
        } else {
          this.commission.input = ((currentInput / price) * 100).toFixed(2);
        }
      }
    },
  },
  methods: {
    addValueToProject() {
      const value = parseFloat(this.payload.additional_value);
      if (!Number.isNaN(value) && value > 0) {
        this.project.price = parseFloat(this.project.price) + value;
        this.payload.additional_value = '';
        this.$toast.success('Valor acrescido ao projeto!');
      }
    },
    async getProject() {
      const { data } = await ProjectService.get(this.id);

      // Guarda qual era o tipo selecionado antes de atualizar os dados
      const currentType = this.commission.type;

      this.project = data.project;
      this.project_product = data.project_product;
      this.product = data.product;
      this.agent = data.project.agent;

      // Se já tinha carregado antes e o usuário estava usando Valor Fixo (R$), mantém em R$
      if (this.load && currentType === 'value') {
        this.commission.type = 'value';
        const recalculatedValue = parseFloat(this.project.price) * (this.project.agent_percentage / 100);
        this.commission.input = recalculatedValue.toFixed(2);
      } else {
        // Se for o primeiro load ou o usuário estiver usando %, carrega normal
        this.commission.type = 'percent';
        this.commission.input = this.project.agent_percentage || 0;
      }

      this.project_components = data.components.map((item) => ({
        quantity: item.quantity,
        description: item.description,
      }));

      this.discounts = data.project.discounts.map((item) => ({
        user: item.user.agent !== null ? item.user.agent.name : item.user.name,
        value_project: this.$options.filters.currency(item.price),
        price_final: this.$options.filters.currency(item.price_with_discount),
        value_discount: this.$options.filters.currency(item.discount_value),
        percentage_discount: `${item.percentage_discount / 1}%`,
      }));

      Object.keys(data.all_status_departments || {}).forEach((key) => {
        if (data.all_status_departments[key] !== null) {
          this.all_status_departments.push({
            department: data.all_status_departments[key].status.department.name,
            status: data.all_status_departments[key].status.name,
            operator: data.all_status_departments[key].user.name,
          });
        }
      });

      this.load = true;
    },

    async deleteDiscount(index) {
      const disc = this.project.discounts[index].id;
      const data = { id: disc };
      if (index === (this.project.discounts.length - 1)) {
        await ProjectService.deleteDiscount(data)
          .then(() => {
            this.getProject();
          }).finally(() => {
            this.$toast.success('Desconto excluído com sucesso');
          });
      } else {
        this.$toast.error('Exclua o último desconto por favor');
      }
    },

    confirmChangeCommission() {
      this.$toast.question(
        'Deseja realmente alterar a sua comissão sobre a venda?',
        'Atenção',
        this.getQuestionObj(this.updateCommission, '', 'Comissão alterada com sucesso'),
      );
    },

    async updateCommission() {
      const payload = {
        id: this.id,
        agent_percentage: this.final_commission_percentage,
      };

      try {
        await ProjectService.edit(payload);
        this.getProject();
      } catch (error) {
        console.error(error);
      }
    },

    async updateProjectDiscount() {
      this.$v.payload.$touch();
      if (this.$v.payload.$invalid) return;

      // Se o usuário preencheu o campo de valor adicional, salva o novo valor do projeto
      if (this.payload.additional_value && !Number.isNaN(parseFloat(this.payload.additional_value))) {
        const newValue = parseFloat(this.payload.additional_value);
        if (newValue > 0) {
          this.project.price = parseFloat(this.project.price) + newValue;
          this.payload.additional_value = '';
        }
      }

      const payload = {
        id: this.id,
        project_discount: {
          price: this.project.price,
          project_id: this.id,
          price_with_discount: this.price_final,
          discount_value: this.value_discount,
          user_id: this.user.id,
          percentage_discount: this.final_discount_percentage,
        },
        price: this.project.price,
      };

      try {
        await ProjectService.edit(payload);
        this.getProject();

        this.payload.discount_input = 0;
        this.payload.discount_type = 'percent';
        this.$v.$reset();
      } catch (error) {
        console.error(error);
      }
    },
  },
  created() {
    this.getProject();
  },
};
</script>

<style lang="css" scoped>
span {
  color: #ff904d;
}

.hover {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #0000009e;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff !important;
  opacity: 0;
}

.hover:hover {
  opacity: 1;
  transition: all ease-in-out .5s;
}

.hover button {
  color: #fff;
}
</style>
